import { SolidDashLineChart } from "../ChartJs";
import React from "react";
import { LongText, prefixValue, suffixValue, Unit } from "../processors";
import { CategoryTheme } from "../misc";
import { getColor } from "../../themes";
import { Paragraph } from "../Paragraph";
import { useYearsCleaner } from "./useYearsCleaner";

export interface LineWithAverageDataProps {
    measure: string;
    unit?: Unit;
    years: number[];
    lineDataSeriesName: string;
    providerMedianData: number[];
    providerMedianSeriesName: string;
    providerMedianAnnotation: string;
    lineData: number[];
    theme?: CategoryTheme;
    header?: LongText;
    footer?: LongText;
}

export const LineWithAverageData: React.FC<LineWithAverageDataProps> = ({
    measure,
    unit,
    header,
    footer,
    theme,
    years,
    lineData,
    lineDataSeriesName,
    // largeProviderAverageData,
    providerMedianData,
    providerMedianAnnotation,
    providerMedianSeriesName
}) => {
    const {
        years: _years,
        linesData: _linesData,
        providerMedianData: _providerMedianDatas
    } = useYearsCleaner(years, [lineData], [providerMedianData]);

    const _lineData = _linesData?.[0];
    const _providerMedianData = _providerMedianDatas?.[0];

    if (!_years?.length || !_lineData?.length || !_providerMedianData.length) return null;

    return (
        <>
            {header != null && (
                <Paragraph
                    nid={0}
                    status={true}
                    title={""}
                    text={header}
                    className={`marginBottom headline chart-headline`}
                />
            )}
            <SolidDashLineChart
                measure={measure}
                unit={unit}
                labels={_years}
                dashAnnotation={providerMedianAnnotation}
                dashLabel={providerMedianSeriesName}
                dashValues={_providerMedianData}
                solidValues={_lineData}
                solidLabel={lineDataSeriesName}
                solidColor={getColor(theme)}
                yAxisLabelFormatter={value => {
                    return `${prefixValue(value, unit) ?? ""}${value}${suffixValue(value, unit) ?? ""}`;
                }}
            />
            {footer != null && <Paragraph nid={0} status={true} title={""} text={footer} />}
        </>
    );
};
